import React from "react";

/**
 * Hidden honeypot field. Real users never see or focus it; bots that scrape
 * the DOM and fill every input will set it, and the backend rejects with 400.
 *
 * Critical attributes:
 *   - visually hidden but reachable in DOM (display:none alone trips some bots)
 *   - tabIndex={-1} + aria-hidden so a11y tools skip it
 *   - autoComplete="off" + label="please leave blank" as a final layer
 *
 * Usage:
 *   const [website, setWebsite] = useState("");
 *   <Honeypot value={website} onChange={setWebsite} name="website" />
 *   // then send website along in your POST body
 */
export default function Honeypot({ value, onChange, name = "website" }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-10000px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <label htmlFor={`hp-${name}`}>Please leave this field blank</label>
      <input
        id={`hp-${name}`}
        type="text"
        name={name}
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
